import { Dispatch, SetStateAction } from 'react';

import { useChatProviderConfig } from './cropwise-ai.container.hook';
import { CropwiseAiTabsEnum } from './cropwise-ai.enum';
import * as Styled from './cropwise-ai.style';
import { ChatProvider } from './cropwise-ai-chat.context';
import { CropwiseAiConversation } from './cropwise-ai-convesation/cropwise-ai-conversation.component';
import { CropwiseAiHeader } from './cropwise-ai-header/cropwise-ai-header.component';
import { CropwiseAiHistory } from './cropwise-ai-history/cropwise-ai-history.component';
import { CropwiseAiInput } from './cropwise-ai-input/cropwise-ai-input.component';

interface CropwiseAiContainerProps {
  showType: CropwiseAiTabsEnum;
  setShowType: Dispatch<SetStateAction<CropwiseAiTabsEnum>>;
}

const CropwiseAiContainer = ({
  showType,
  setShowType,
}: CropwiseAiContainerProps) => {
  const {
    sessionId,
    setSessionId,
    url,
    audioUrl,
    authHeader,
    threadId,
    historyVersion,
    onStreamComplete,
  } = useChatProviderConfig();

  return (
    <ChatProvider
      key={threadId}
      url={url}
      audioUrl={audioUrl}
      authHeader={authHeader}
      threadId={threadId}
      onStreamComplete={onStreamComplete}
    >
      <Styled.Container
        isFullscreen={showType === CropwiseAiTabsEnum.FULL_SCREEN}
        isCollapsed={showType === CropwiseAiTabsEnum.COLLAPSE}
      >
        <Styled.Body>
          {showType === CropwiseAiTabsEnum.FULL_SCREEN && (
            <Styled.LeftContainer>
              <CropwiseAiHistory
                sessionId={sessionId}
                showType={showType}
                setSessionId={setSessionId}
                historyVersion={historyVersion}
              />
            </Styled.LeftContainer>
          )}
          <Styled.RightContainer>
            <CropwiseAiHeader
              sessionId={sessionId}
              setShowType={setShowType}
              showType={showType}
              setSessionId={setSessionId}
            />
            <CropwiseAiConversation showType={showType} sessionId={sessionId} />
            <CropwiseAiInput showType={showType} />
          </Styled.RightContainer>
        </Styled.Body>
      </Styled.Container>
    </ChatProvider>
  );
};

export { CropwiseAiContainer };
